import Keycloak from 'keycloak-js';

// import the keycloak config
const URL = import.meta.env.VITE_KEYCLOAK_URL;
const REALM = import.meta.env.VITE_KEYCLOAK_REALM;
const CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID_FE;

// check if the config are loaded
if (!URL || !REALM || !CLIENT_ID) {
  throw new Error('Keycloak configuration is missing');
}

const keycloak = new Keycloak({
  url: URL,
  realm: REALM,
  clientId: CLIENT_ID,
});

export default keycloak;
